import React from 'react'

// material ui
import Container from '@mui/material/Container'

// components
import EditPersonHeader from 'components/shared/EditPersonHeader'
import Loading from 'components/atoms/Loading'
import Breadcrumbs from 'components/shared/Breadcrumbs'

// containers
import Form from 'components/account/Campers/Form'

const EditCamper = props => {
  const { account, season, camper, queryLoading, mutationLoading, form } = props

  function buttonText() {
    if (!camper) {
      return 'Loading…'
    }

    if (!camper.confirmed) {
      return mutationLoading ? 'Confirming…' : 'Confirm'
    }

    return mutationLoading ? 'Saving…' : 'Save'
  }

  return (
    <Container maxWidth='md'>
      <Breadcrumbs
        crumbs={[
          ['Account Overview', '/'],
          ['Campers'],
          [camper ? camper.firstName : '…']
        ]}
      />
      <EditPersonHeader
        personType='Camper'
        person={camper}
        season={season}
        account={account}
      />
      {queryLoading || (!form?.id && !!camper) ? (
        <Loading />
      ) : (
        <Form
          buttonText={buttonText()}
          editMode
          showFormFields={!!camper}
          {...props}
        />
      )}
    </Container>
  )
}

export default EditCamper
